import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import CalendarHeader from '../Home/Mobile/CalendarHeader/CalendarHeader';
import ModernCalendar from '../Home/Mobile/Calendar/Calendar';

import calendar from '../../assets/icons/calendar.svg';
import setting from '../../assets/icons/setting.svg';

import './Year.css';

const days = [
    'شنبه',
    'یکشنبه',
    'دوشنبه',
    'سه شنبه',
    'چهارشنبه',
    'پنج شنبه',
    'جمعه',
];

const persian = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
];

export default class Year extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDay: { year: 1399, month: 10, day: 20 },
        }
    }

    setSelectedDay = (value) => {
        this.setState({
            selectedDay: value,
        })
    }
    render() {
        return (
            <div className="mobile-year">
                <div className="mobile-year__top d-flex flex-column">
                    <div className="mobile-year__header d-flex">
                        <CalendarHeader date={this.state.selectedDay} />
                        <div className="mobile-year__header--buttons d-flex">
                            <Link to="/"><img src={calendar} /></Link>
                            <Link to="/setting"><img src={setting} /></Link>
                        </div>
                    </div>
                    <div className="mobile-year__weekday d-flex">
                        {
                            days.map(item => (
                                <div key={item}>{item}</div>
                            ))
                        }
                    </div>
                </div>
                <div className="mobile-year__content">
                    {
                        persian.map((item, index) => (
                            <div className="mobile-year__month d-flex flex-column" key={index}>
                                <div className="mobile-year__month--header d-flex flex-column">
                                    <span></span>
                                    <h3>{item} {this.state.selectedDay.year}</h3>
                                </div>
                                <ModernCalendar
                                    headerAccess={false}
                                    setSelectedDay={this.setSelectedDay}
                                    rotate={true}
                                    monthYear={{ year: this.state.selectedDay.year, month: index + 1, day: 10 }}
                                    swipeAccess={false}
                                    weekAccess={false}
                                />
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }
}